import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError, map } from "rxjs/operators";
import { environment } from "@environments/environment";
import { Loan, Invoice } from "@app/models";
import { AuthenticationService } from "./authentication.service";
import { Account } from "@app/models/account";
@Injectable({ providedIn: "root" })
export class PreapprovalService {
  constructor(
    private http: HttpClient
  ) { }

  getOpportinitiesByMrpId(mrpId) {
    return this.http.get<any>(`${environment.scs_url_lh}/portal/get_requests?mrp_id=${mrpId}`)
      .pipe(map(res => {
        return res;
      }));
  }

  getOpportinitiesByMrpIdPaginate(mrpId:any, limit:any, offset:any){
    return this.http.get<any>(`${environment.scs_url_lh}/portal/get_requests_paginate?mrp_id=${mrpId}&limit=${limit}&offset=${offset}`)
      .pipe(map(res => {
        return res;
      }));
  }
}
